var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-display',{staticClass:"d-none d-lg-block text-muted",staticStyle:{"font-size":"90%"},attrs:{"value":new Date().toISOString(),"dateFormat":"dddd D MMMM YYYY","icon-class":""}})}
var staticRenderFns = []

export { render, staticRenderFns }